export const USER_LOGIN = "USER_LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_CONTACTS = "UPDATE_CONTACTS";
export const CREATE_CHAT = "CREATE_CHAT";
export const CHANGE_ISCHATS = "CHANGE_ISCHATS";
export const UPDATE_RIGHT_PANEL = "UPDATE_RIGHT_PANEL_CHAT";
export const UPDATE_CHAT = "UPDATE_CHAT";
export const UPDATE_SEARCH_PHRASE = "UPDATE_SEARCH_PHRASE";
